import Component from './AddDeal.container';

export default Component;
